export const SignupType = Object.freeze({
  capitalReport: 'CAPITAL_REPORT',
  marketplacePartnership: 'MARKETPLACE_PARTNERSHIP',
  marketplaceWidget: 'WIDGET',
  xeroMarketplace: 'XERO_MARKETPLACE',
  introducerTeam: 'INTRODUCER_TEAM',
  anonymousQuestionnaire: 'ANONYMOUS_QUESTIONNAIRE',
  onboardClient: 'ONBOARD_CLIENT',
});

export const SignupTypeLabel = Object.freeze({
  [SignupType.capitalReport]: 'capitalReport',
  [SignupType.marketplacePartnership]: 'marketplacePartnership',
  [SignupType.marketplaceWidget]: 'widget',
  [SignupType.xeroMarketplace]: 'xeroMarketplace',
  [SignupType.introducerTeam]: 'introducerTeam',
  [SignupType.anonymousQuestionnaire]: 'anonymousQuestionnaire',
  [SignupType.onboardClient]: 'onboardClient',
});

export const DEFAULT_SIDEBAR_INVITE_TITLE = "You've been invited to signup to Capitalise";

export const signupSidebarInviteTitle = Object.freeze({
  [SignupType.capitalReport]: "You've been invited to view your capital report.",
  [SignupType.marketplacePartnership]: DEFAULT_SIDEBAR_INVITE_TITLE,
  [SignupType.marketplaceWidget]: DEFAULT_SIDEBAR_INVITE_TITLE,
  [SignupType.xeroMarketplace]: DEFAULT_SIDEBAR_INVITE_TITLE,
  [SignupType.introducerTeam]: DEFAULT_SIDEBAR_INVITE_TITLE,
  [SignupType.anonymousQuestionnaire]: DEFAULT_SIDEBAR_INVITE_TITLE,
  [SignupType.onboardClient]: DEFAULT_SIDEBAR_INVITE_TITLE,
});

export const signupSidebarInviteBody = Object.freeze({
  [SignupType.capitalReport]: (data) => (
    <>
      <b>{data.name}</b> from {data.companyName} has invited you to sign up and view the capital
      report for <b>{data.businessCompanyName}.</b>
    </>
  ),
  [SignupType.marketplacePartnership]: (data) => (
    <>
      <b>{data.name}</b> has invited you to join the {data.companyName} Capital Advisory platform,
      powered by Capitalise.
    </>
  ),
  [SignupType.marketplaceWidget]: (data) => (
    <>
      <b>{data.companyName}</b> has invited you to join Capitalise.
    </>
  ),
  [SignupType.xeroMarketplace]: (data) => (
    <>
      <b>{data.name}</b> has invited you to join the {data.companyName} Capital Advisory platform,
      powered by Capitalise.
    </>
  ),
  [SignupType.introducerTeam]: (data) => (
    <>
      <b>{data.name}</b> has invited you to join the {data.companyName} Capital Advisory platform,
      powered by Capitalise.
    </>
  ),
  [SignupType.anonymousQuestionnaire]: (data) => (
    <>
      <b>{data.name}</b> has invited you to join the {data.companyName} Capital Advisory platform,
      powered by Capitalise.
    </>
  ),
  [SignupType.onboardClient]: (data) => (
    <>
      <b>{data.name}</b> from <b>{data.companyName}</b> has invited you to sign up and monitor the
      Experian credit profile for <b>{data.businessCompanyName}</b>
    </>
  ),
});
